export const LOADING_SPINNER_COLOR = '#00B176' as const;
